import { palette } from '@src/theme';
import { BaseButtonProps } from './interface';

const LOADING_SPINNER_COLOR_MAP = {
  contained: {
    primary: palette.surface.paper,
    secondary: palette.state.teal.secondary,
    destructive: palette.surface.paper,
  },
  outlined: {
    default: palette.state.teal.secondary,
  },
  text: {
    primary: palette.state.teal.secondary,
    secondary: palette.state.teal.secondary,
    destructive: palette.state.error.secondary,
  },
};

export const calculateLoadingSpinnerColor = (medelyProps: BaseButtonProps) => {
  const isContainedVariant = !medelyProps.variant || medelyProps.variant === 'contained';
  if (isContainedVariant) {
    return (
      LOADING_SPINNER_COLOR_MAP.contained[medelyProps.color!] ??
      LOADING_SPINNER_COLOR_MAP.contained.primary
    );
  } else if (medelyProps.variant === 'outlined') {
    return LOADING_SPINNER_COLOR_MAP.outlined.default;
  } else if (medelyProps.variant === 'text') {
    return (
      LOADING_SPINNER_COLOR_MAP.text[medelyProps.color!] ?? LOADING_SPINNER_COLOR_MAP.text.primary
    );
  }
  return palette.surface.paper;
};
